import { type FC, useState } from "react";
import { createPortal } from "react-dom";

export const ModalSubmitForApproval: FC<{
	onSubmit: (note?: string) => void;
	onClose: () => void;
	submitting: boolean;
}> = ({ onSubmit, onClose, submitting }) => {
	const [note, setNote] = useState("");

	return createPortal(
		<div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Submit for Approval</h5>
						<button
							type="button"
							className="btn-close"
							onClick={onClose}
							disabled={submitting}
						/>
					</div>
					<div className="modal-body">
						<p>
							This campaign will be submitted for review by an approver before
							it can be published.
						</p>
						<div className="mb-3">
							<label htmlFor="approval-note" className="form-label">
								Note for reviewer (optional)
							</label>
							<textarea
								id="approval-note"
								className="form-control"
								rows={3}
								value={note}
								onChange={(e) => setNote(e.target.value)}
								placeholder="Add any context or notes for the reviewer..."
								disabled={submitting}
							/>
						</div>
					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-secondary"
							onClick={onClose}
							disabled={submitting}
						>
							Cancel
						</button>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => onSubmit(note.trim() || undefined)}
							disabled={submitting}
						>
							{submitting ? "Submitting..." : "Submit for Approval"}
						</button>
					</div>
				</div>
			</div>
		</div>,
		document.body,
	);
};
